// EmptyState — centered "nothing here yet" panel with an optional call to
// action. Keeps the eyebrow/title/description rhythm consistent across the
// many list views that can legitimately be empty.
import { ReactNode } from 'react';
import { Card } from './Card';

export interface EmptyStateProps {
  readonly eyebrow?: string;
  /** Optional decorative glyph rendered above the title (e.g. a lucide icon). */
  readonly icon?: ReactNode;
  readonly title: ReactNode;
  readonly description?: ReactNode;
  readonly action?: ReactNode;
}

export function EmptyState({ eyebrow = 'empty orbit', icon, title, description, action }: EmptyStateProps) {
  return (
    <Card className="p-10 text-center">
      {icon ? (
        <div className="inline-flex items-center justify-center mb-3 text-fg-subtle">{icon}</div>
      ) : null}
      {eyebrow ? <p className="orb-eyebrow mb-2">{eyebrow}</p> : null}
      <h2 className="font-display text-xl font-semibold text-fg mb-2">{title}</h2>
      {description ? (
        <p className="text-fg-muted text-sm max-w-md mx-auto">{description}</p>
      ) : null}
      {action ? <div className="mt-5 flex justify-center">{action}</div> : null}
    </Card>
  );
}
